/**
 *
 */
export default class RestApi {
  auth = {
    login: (data) => $app.api.post([ 'auth/login', ]).data(data),
    loginBy: (data) => $app.api.post([ 'auth/login-by-token', ]).data(data),
    info: () => $app.api.get([ 'auth/info', ]),
    recoverSendCode: (data) => $app.api.post([ 'auth/admin-recover/send-code', ]).data(data),
    recoverCheckCode: (data) => $app.api.post([ 'auth/admin-recover/check-code', ]).data(data),
    recover: (data) => $app.api.post([ 'auth/admin-recover', ]).data(data),
  }
  custom = {
    yumiSalary: (data) => $app.api.post([ 'custom-api/yumi-salary', ]).data(data),
  }
  zkteco = {
    syncTenant: (companyId) => $app.api.post([ 'zkteco/sync-company*', companyId]),
  }
  hikJournal = {
    getJournal: (companyId, userId) => $app.api.get([ 'companies*/users*/journal', companyId, userId, ]),
    syncUserToPoint: (companyId, userId, pointId) => $app.api.post([ 'companies*/users*/location-points*', companyId, userId, pointId, ]),
    removeUserFromPoint: (companyId, userId, pointId) => $app.api.post([ 'companies*/users*/location-points*/remove', companyId, userId, pointId, ]),
    syncUserToAll: (companyId, userId) => $app.api.post([ 'companies*/users*/sync-all', companyId, userId, ]),
    syncLocPoint: (companyId, pointId) => $app.api.post([ 'companies*/location-points*/sync-all', companyId, pointId, ]),
    getSyncModel: (syncId) => $app.api.get([ 'hik-syncing*', syncId, ]),
    getLocJournal: (companyId, pointId) => $app.api.get([ 'companies*/location-points*/journal', companyId, pointId, ]),
  }

  files = {
    get: (id) => $app.api.get([ 'files*', id]),
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
  }

  accesses = {
    getPermits: () => $app.api.get([ 'auth/permits', ]),
    getRoles: () => $app.api.get([ 'auth/roles', ]),
    deleteRole: (id) => $app.api.delete([ 'auth/roles*', id, ]),
    createRole: (data) => $app.api.post([ 'auth/roles', ]).data(data),
    editRole: (id, data) => $app.api.patch([ 'auth/roles*', id, ]).data(data),
    detachAccess: (id) => $app.api.delete([ 'auth/accesses*', id, ]),
    createAccess: (data) => $app.api.post([ 'auth/accesses', ]).data(data),
  }

  breaks = {
    get: (companyId, userId) => $app.api.get([ 'companies*/users*/sheet-breaks', companyId, userId, ]),
    edit: (companyId, breakId, data) => $app.api.patch([ 'companies*/sheet-breaks*', companyId, breakId, ]).data(data),
    delete: (companyId, userId, breakId) => $app.api.delete([ 'companies*/users*/sheet-breaks*', companyId, userId, breakId, ]),
    create: (companyId, userId, data) => $app.api.post([ 'companies*/users*/sheet-breaks-admin', companyId, userId, ]).data(data),
  }

  locationPoints = {
    get: (companyId, id) => $app.api.get([ 'companies*/location-points*', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/location-points', companyId, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'location-points*', id, ]).data(data),
    stats: (id, data) => $app.api.post([ 'location-points*/visit-stats', id, ]).data(data),
    getPattern: (companyId, id) => $app.api.get([ 'companies*/location-points*/download-pattern', companyId, id, ]),
    delete: (id) => $app.api.delete([ 'location-points*', id, ]),
    getVisitsPattern: (companyId, id, data) => $app.api.post([ 'companies*/location-points*/download-visits-pattern', companyId, id, ]).data(data),
    getEditorJournal: (companyId, id, data) => $app.api.post([ 'companies*/location-points*/editor-journal', companyId, id, ]).data(data),
  }

  positions = {
    get: (companyId, id) => $app.api.get([ 'companies*/positions*', companyId, id, ]),
    getSettings: (companyId, id) => $app.api.get([ 'companies*/positions*/settings', companyId, id, ]),
    getUsers: (companyId, id) => $app.api.get([ 'companies*/positions*/users', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/positions', companyId, ]).data(data),
    remove: (companyId, id) => $app.api.delete([ 'companies*/positions*', companyId, id, ]),
    edit: (companyId, id, data) => $app.api.patch([ 'companies*/positions*', companyId, id, ]).data(data),
  }

  companies = {
    get: (id) => $app.api.get([ 'companies*', id, ]),
    edit: (id, data) => $app.api.patch([ 'companies*', id, ]).data(data),
    removePhoto: (id) => $app.api.patch([ 'companies*/remove-photo', id, ]),
    loadExcel: (id, data) => $app.api.post([ 'companies*/make-sheet', id, ]).data(data),
    loadStats: (id, data) => $app.api.post([ 'companies*/excel-stats', id, ]).data(data),
    uploadPattern: (companyId, fileId, data) => $app.api.post([ 'companies*/files*/import', companyId, fileId, ]).data(data),
    checkUploadProgress: (companyId, importId) => $app.api.get([ 'companies*/imports*', companyId, importId, ]),

    export: (companyId, data) => $app.api.post([ 'companies*/exports', companyId, ]).data(data),
    deleteExport: (companyId, exportId) => $app.api.delete([ 'companies*/exports*', companyId, exportId, ]),
    getExports: (companyId) => $app.api.get([ 'companies*/exports', companyId, ]),
  }

  departments = {
    get: (companyId, id) => $app.api.get([ 'companies*/departments*', companyId, id, ]),
    getSettings: (companyId, id) => $app.api.get([ 'companies*/departments*/settings', companyId, id, ]),
    getUsers: (companyId, id) => $app.api.get([ 'companies*/departments*/users', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/departments', companyId, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'departments*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'departments*', id, ]),
  }

  tgstatsusers = {
    get: () => $app.api.get([ 'tg-stats-company/users', ]),
    getAll: () => $app.api.get([ 'tg-stats-company/users/all', ]),

    getSettings: (companyId, id) => $app.api.get([ 'companies*/departments*/settings', companyId, id, ]),
    getUsers: (companyId, id) => $app.api.get([ 'companies*/departments*/users', companyId, id, ]),
    addUsers: (data) => $app.api.post([ 'tg-stats-company/users', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'departments*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'tg-stats-company-users*', id, ]),
    saveAccesses: (id, data) => $app.api.post([ 'tg-stats-company-users*/accesses', id, ]).data(data),
    getAccesses: (id) => $app.api.get([ 'tg-stats-company-users*/accesses', id, ]),

  }

  tgstatstypes = {
    get: () => $app.api.get([ 'tg-stats-type-company', ]),
    // getAll: () => $app.api.get([ 'tg-stats-company/users/all', ]),
    //
    getTypes: () => $app.api.get([ 'tg-stats-types', ]),

    getSettings: (companyId, id) => $app.api.get([ 'companies*/departments*/settings', companyId, id, ]),
    getUsers: (companyId, id) => $app.api.get([ 'companies*/departments*/users', companyId, id, ]),
    addTypes: (data) => $app.api.post([ 'tg-stats-type-company', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'tg-stats-type-company*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'tg-stats-type-company*', id, ]),
  }

  sheets = {
    getUserSheet: (sheetId) => $app.api.get([ 'sheets*/user-sheet', sheetId, ]),
    attachBranches: (data) => $app.api.patch([ 'sheets-attach-points', ]).data(data),
  }

  users = {
    get: (id) => $app.api.get([ 'users*', id, ]),
    getSettings: (id) => $app.api.get([ 'users*/settings', id, ]),
    recalcSheet: (companyId, id, data) => $app.api.post([ 'companies*/users*/recalc-user', companyId, id, ]).data(data),
    fireUser: (id, data) => $app.api.post([ 'users*/fire', id, ]).data(data),
    unFireUser: (id) => $app.api.post([ 'users*/un-fire', id, ]),
    editSheetDay: (id, data) => $app.api.patch([ 'users*/edit-sheet-day', id, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'users*', id, ]).data(data),
    editDocuments: (id, data) => $app.api.patch([ 'users*/documents', id, ]).data(data),
    deleteField: (id, data) => $app.api.patch([ 'users*/delete-field', id, ]).data(data),
    create: (companyId, data) => $app.api.post([ 'companies*/users', companyId, ]).data(data),
    getByCompany: (companyId, data) => $app.api.get([ 'companies*/users', companyId, ]).data(data),
    getByBranch: (companyId, branchId) => $app.api.get([ 'companies*/branches*/users', companyId, branchId, ]),
    getByLocationPoint: (companyId, locPointId) => $app.api.get([ 'companies*/location-points*/users', companyId, locPointId, ]),
    delete: (id) => $app.api.delete([ 'users*', id, ]),
    editPass: (id, data) => $app.api.patch([ 'users*/password', id, ]).data(data),
    getByUser: (userId) => $app.api.get([ 'users*/mood-questionaire', userId, ]),
    getCompany: (id) => $app.api.get([ 'companies*/mood-questionaire', id, ]),
  }

  applications = {
    get: (companyId, id) => $app.api.get([ 'companies*/applications*', companyId, id, ]),
    createMulti: (companyId, templateId, data) => $app.api.post([ 'companies*/applications-multi-create*', companyId, templateId, ]).data(data),
    delete: (companyId, id) => $app.api.delete([ 'companies*/applications*', companyId, id, ]),
    deleteMulti: (companyId, data) => $app.api.post([ 'companies*/applications-delete-multi', companyId, ]).data(data),
    editStatus: (companyId, id, data) => $app.api.patch([ 'companies*/applications*/status', companyId, id, ]).data(data),
    editStatusMulti: (companyId, data) => $app.api.patch([ 'companies*/applications-status-multi', companyId, ]).data(data),
    edit: (companyId, id, data) => $app.api.patch([ 'companies*/applications*', companyId, id, ]).data(data),

    approveStage: (companyId, applicationId, stageApprovalId, data = {}) =>
      $app.api.post([ 'companies*/applications*/stages*/approve', companyId, applicationId, stageApprovalId, ]).data(data),
    declineStage: (companyId, applicationId, stageApprovalId, data = {}) =>
      $app.api.post([ 'companies*/applications*/stages*/decline', companyId, applicationId, stageApprovalId, ]).data(data),
    getMyToReview: (companyId) => $app.api.get([ 'my/companies*/applications-to-review-admin', companyId, ]),
    groupCandidates: (companyId, id) => $app.api.get([ 'companies*/applications*/group-candidates', companyId, id, ]),
    createGroup: (companyId, id, data) => $app.api.post([ 'companies*/applications*/group', companyId, id, ]).data(data),
  }
  applicationGroups = {
    get: (companyId) => $app.api.get([ 'companies*/application-groups', companyId, ]),
    getOne: (companyId, groupId) => $app.api.get([ 'companies*/application-groups*', companyId, groupId, ]),
  }

  applicationTemplates = {
    get: (companyId, id) => $app.api.get([ 'companies*/application-templates*', companyId, id, ]),
    edit: (companyId, id, data) => $app.api.patch([ 'companies*/application-templates*', companyId, id, ]).data(data),
    create: (companyId, data) => $app.api.post([ 'companies*/application-templates', companyId, ]).data(data),
    delete: (companyId, id) => $app.api.delete([ 'companies*/application-templates*', companyId, id, ]),
  }

  notifications = {
    get: (companyId, id) => $app.api.get([ 'companies*/notifications*', companyId, id, ]),
    delete: (companyId, id) => $app.api.delete([ 'companies*/notifications*', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/notifications', companyId, ]).data(data),
  }

  documents = {
    get: (companyId, id) => $app.api.get([ 'companies*/documents*', companyId, id, ]),
    delete: (companyId, id) => $app.api.delete([ 'companies*/documents*', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/documents', companyId, ]).data(data),
  }

  branches = {
    get: (companyId, branchId) => $app.api.get([ 'companies*/branches*', companyId, branchId, ]),
    getLocationPoints: (branchId) => $app.api.get([ 'branches*/location-points', branchId, ]),
    getPattern: (companyId, branchId) => $app.api.get([ 'companies*/branches*/download-pattern', companyId, branchId, ]),
    create: (id, data) => $app.api.post([ 'companies*/branches', id, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'branches*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'branches*', id, ]),
  }
  settingsTemplates = {
    get: (modelId) => $app.api.get([ 'setting-templates*', modelId, ]),
    create: (data) => $app.api.post([ 'setting-templates', ]).data(data),
    attach: (data) => $app.api.post([ 'setting-templates-attach', ]).data(data),
    unlink: (data) => $app.api.post([ 'setting-templates-unlink', ]).data(data),
    edit: (companyId, id, data) => $app.api.patch([ 'companies*/setting-templates*', companyId, id, ]).data(data),
    delete: (companyId, id) => $app.api.delete([ 'companies*/setting-templates*', companyId, id, ]),
  }
  approvalstages = {
    get: (id) => $app.api.get([ 'approval-stages* ', id, ]),
    edit: (id, data) => $app.api.patch([ 'approval-stages*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'approval-stages*', id, ]),
    create: (data) => $app.api.post([ 'approval-stages', ]).data(data),
  }

  visits = {
    getStats: (companyId, data) => $app.api.post([ 'companies*/visit-stats', companyId, ]).data(data),
    getStatsReport: (companyId, data) => $app.api.post([ 'companies*/visit-stats-report', companyId, ]).data(data),
    getTowersStats: (companyId, data) => $app.api.post([ 'companies*/visit-stats-towers', companyId, ]).data(data),
    getForMap: (userId, data) => $app.api.post([ 'users*/visits-for-map', userId, ]).data(data),
    getUsers: (userId) => $app.api.get([ 'users*/visits', userId, ]),
    getByBranch: (companyId, branchId) => $app.api.get([ 'companies*/branches*/visits', companyId, branchId, ]),
    getByLocationPoint: (companyId, locPointId) => $app.api.get([ 'companies*/location-points*/visits', companyId, locPointId, ]),
    create: (companyId, userId, data) => $app.api.post([ 'visits/companies*/users*', companyId, userId, ]).data(data),
    edit: (visitId, companyId, data) => $app.api.patch([ 'visits*/companies*', visitId, companyId, ]).data(data),
    delete: (visitId, companyId) => $app.api.delete([ 'visits*/companies*', visitId, companyId, ]),
  }

  checklists = {
    get: (id) => $app.api.get([ 'checklists*', id, ]),
    remove: (checklistId) => $app.api.delete([ 'checklists', checklistId, ]),
    create: (data) => $app.api.post([ 'checklists', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'checklists*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'checklists*', id, ]),
    getPoints: (id) => $app.api.get([ 'checklists*/checklistpoints', id, ]),
    getTasks: (id) => $app.api.get([ 'checklists*/checklisttasks', id, ]),
    getUsers: (id) => $app.api.get([ 'checklists*/checklistusers', id, ]),

  }
  checklistTasks ={
    create: (data) => $app.api.post([ 'checklisttasks', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'checklisttasks*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'checklisttasks*', id, ]),

  }
  checklistAnswers = {
    completed: (id) => $app.api.post([ 'checklistanswers*/completed', id,]),
    rework: (id, data) => $app.api.post([ 'checklistanswers*/rework', id,]).data(data),
    canceled: (id, data) => $app.api.post([ 'checklistanswers*/canceled', id,]).data(data),

    // data = { comment: '...' }
  }
  checklistResults={
    getResults: (id) => $app.api.get([ 'checklists*/results', id, ]),
    getOne: (id) => $app.api.get([ 'checklists/results*', id, ]),
    completed: (id) => $app.api.post([ 'checklistresults*/completed', id, ]),
    cancel: (id,data) => $app.api.post([ 'checklistresults*/cancel', id, ]).data(data),


  }
  checklistPoints = {
    get: (id) => $app.api.get([ 'checklistpoints*', id, ]),
    getActive: () => $app.api.get([ 'checklistpoint/active', ]),

    getOne: (id) => $app.api.get([ 'checklistpoints*', id, ]),
    create: (data) => $app.api.post([ 'checklistpoints', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'checklistpoints*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'checklistpoints*', id, ]),
  }
  checklistUsers ={
    create: (id, data) => $app.api.post([ 'checklists*/add-users', id, ]).data(data),
    delete: (id, data) => $app.api.delete([ 'checklists*/delete-users', id, ]).data(data),
  }
  checklistPointList ={
    create: (id, data) => $app.api.post([ 'checklists*/add-points', id, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'checklistpointlist*', id, ]).data(data),
    delete: (id, data) => $app.api.delete([ 'checklists*/delete-points', id, ]).data(data),
  }
  checklistsgroups = {
    get: () => $app.api.get([ 'checklistsgroups', ]),
    getOne: (id) => $app.api.get([ 'checklistsgroups*', id, ]),
    create: (data) => $app.api.post([ 'checklistsgroups', ]).data(data),
    delete: (id) => $app.api.delete([ 'checklistsgroups*', id, ]),
    getPoints: (id) => $app.api.get([ 'group-points*/points', id, ]),
    addPoints: (id, data) => $app.api.post([ 'group-points*/add-points', id, ]).data(data),
    deletePoints: (id, data) => $app.api.delete([ 'group-points*/delete-points', id, ]).data(data),
  }

  checkpoints = {
    get: (checklistId, checkpointId) => $app.api.get([ 'checklists*/checkpoints*', checklistId, checkpointId, ]),
    create: (checklistId, data) => $app.api.post([ 'checklists*/checkpoints', checklistId, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'checkpoints*', id, ]).data(data),
    delete: (checkpointId) => $app.api.delete([ 'checkpoints*', checkpointId, ]),
    getVisists: (checklistId, checkpointId) => $app.api.get([ 'checklists*/checkpoints*/history', checklistId, checkpointId, ]),
    getSheet: (checklistId, checkpointId) => $app.api.get([ 'checklists*/checkpoints*/sheet', checklistId, checkpointId, ]),
  }

  organizations = {
    get: (companyId, id) => $app.api.get([ 'companies*/organizations*', companyId, id, ]),
    getUsers: (companyId, id) => $app.api.get([ 'companies*/organizations*/users', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/organizations', companyId, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'organizations*', id, ]).data(data),
    remove: (id) => $app.api.delete([ 'organizations*', id, ]),
  }

  finesRewards = {
    get: (id) => $app.api.get([ 'fines-rewards*', id, ]),
    getUsers: (id) => $app.api.get([ 'fines-rewards*/users', id, ]),
    getUsersToAttach: (id) => $app.api.get([ 'fines-rewards*/users-to-add', id, ]),
    create: (data) => $app.api.post([ 'fines-rewards', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'fines-rewards*', id, ]).data(data),
    attach: (id, data) => $app.api.post([ 'fines-rewards*/attach-users', id, ]).data(data),
    detach: (id, data) => $app.api.post([ 'fines-rewards*/detach-users', id, ]).data(data),
    remove: (id) => $app.api.delete([ 'fines-rewards*', id, ]),
  }

  schedules = {
    unlink: (id, data) => $app.api.post([ 'schedules*/unlink', id, ]).data(data),
    get: (id) => $app.api.get([ 'schedules*', id, ]),
    getUsers: (id) => $app.api.get([ 'schedules*/users', id, ]),
    getUsersToAttach: (id) => $app.api.get([ 'schedules*/users-to-attach', id, ]),
    getUsersToAttachIds: (id) => $app.api.get([ 'schedules*/users-to-attach-get-ids', id, ]),
    editWorkDays: (id, data) => $app.api.patch([ 'schedules*/edit-sheet', id, ]).data(data),
    create: (data) => $app.api.post([ 'schedules', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'schedules*', id, ]).data(data),
    apply: (id, data) => $app.api.post([ 'schedules*/apply', id, ]).data(data),
    applyToUsers: (id, data) => $app.api.post([ 'schedules*/apply-to-users', id, ]).data(data),
    remove: (id) => $app.api.delete([ 'schedules*', id, ]),
  }

  salary = {
    get: (userId) => $app.api.get([ 'users*/salary', userId, ]),
    calc: (userId, salaryId, data) => $app.api.post([ 'users*/salaries*/calc', userId, salaryId, ]).data(data),
    calcByCompany: (companyId, data) => $app.api.post([ 'companies*/salaries/calc', companyId, ]).data(data),
    create: (userId, data) => $app.api.post([ 'users*/salaries', userId, ]).data(data),
    edit: (userId, salaryId, data) => $app.api.patch([ 'users*/salaries*', userId, salaryId, ]).data(data),
    remove: (userId, salaryId) => $app.api.delete([ 'users*/salaries*', userId, salaryId, ]),
  }

  moodQuestionaire = {
    getStats: (companyId, data) => $app.api.get([ 'companies*/mood-questionaire/stats', companyId, ]).data(data),
    getToken: () => $app.api.post([ 'send-support-token', ]),

  }

  esutd = {
    getPositions: () => $app.api.get([ 'esutd/positions', ]),
    getDictionaries: () => $app.api.get([ 'esutd/dictionaries', ]),
    build: (data) => $app.api.post([ 'esutd/contracts/build', ]).data(data),
    submit: (data) => $app.api.post([ 'esutd/contracts/submit', ]).data(data),
  }

  approvalTemplates = {
    getList: (companyId) => $app.api.get([ 'companies*/approval-templates', companyId, ]),
    get: (id) => $app.api.get([ 'approval-templates*', id, ]),
    editSteps: (id, data) => $app.api.patch([ 'approval-templates*/steps', id, ]).data(data),
  }

  approvalSteps = {
    edit: (id, data) => $app.api.patch([ 'approval-steps*', id, ]).data(data),
  }

  documentTemplates = {
    getList: (companyId) => $app.api.get([ 'companies*/document-templates', companyId, ]),
    get: (id) => $app.api.get([ 'document-templates*', id, ]),
    getDataSources: (id) => $app.api.get([ 'document-templates*/data-sources', id, ]),
  }

  eDocuments = {
    getList: (companyId) => $app.api.get([ 'companies*/edm-documents', companyId, ]),
    get: (id) => $app.api.get([ 'edm-documents*', id, ]),
    getSignedArchive: (id) => $app.api.get([ 'edm-documents*/signed-archive', id, ]).config({ responseType: 'blob', }),
    getVerificationSheet: (id) => $app.api.get([ 'edm-documents*/verification-sheet', id, ]).config({ responseType: 'blob', }),
    getPdfContainer: (id) => $app.api.get([ 'edm-documents*/pdf-container', id, ]).config({ responseType: 'blob', }),
    verify: (uuid) => $app.api.get([ 'edm-documents/verify*', uuid, ]),
    verifySignedArchive: (uuid) => $app.api.get([ 'edm-documents/verify*/signed-archive', uuid, ]).config({ responseType: 'blob', }),
    create: (companyId, data) => $app.api.post([ 'companies*/edm-documents', companyId, ]).data(data),
    cancel: (id) => $app.api.post([ 'edm-documents*/cancel', id, ]),
    enbekBuild: (id, data) => $app.api.post([ 'edm-documents*/enbek/build', id, ]).data(data),
    revokeRequest: (id, data) => $app.api.post([ 'edm-documents*/revoke-request', id, ]).data(data),
    revokeBuild: (id, data) => $app.api.post([ 'edm-documents*/revoke/build', id, ]).data(data),
    revoke: (id, data) => $app.api.post([ 'edm-documents*/revoke', id, ]).data(data),
    revokeDecline: (id, data) => $app.api.post([ 'edm-documents*/revoke-decline', id, ]).data(data),
    enbekContext: (id) => $app.api.get([ 'edm-documents*/enbek/context', id, ]),
    enbekRevokeBuild: (id) => $app.api.post([ 'edm-documents*/enbek/revoke/build', id, ]),
    enbekRevokeSubmit: (id, data) => $app.api.post([ 'edm-documents*/enbek/revoke/submit', id, ]).data(data),
    enbekSubmit: (id, data) => $app.api.post([ 'edm-documents*/enbek/submit', id, ]).data(data),
  }

  documentSigns = {
    getList: (documentId) => $app.api.get([ 'edm-documents*/signs', documentId, ]),
    sign: (id, data) => $app.api.post([ 'document-signs*/sign', id, ]).data(data),
    approve: (id) => $app.api.post([ 'document-signs*/approve', id, ]),
  }

  handFines = {
    get: (companyId, id) => $app.api.get([ 'companies*/hand-fines*', companyId, id, ]),
    remove: (companyId, id) => $app.api.delete([ 'companies*/hand-fines*', companyId, id, ]),
    create: (companyId, data) => $app.api.post([ 'companies*/hand-fines', companyId, ]).data(data),
  }
}
